/**
 * Solve cubic equation in form of t3x^3 + t2x^2 + t1x + t0 = 0
 *
 * Inspired by http://www.pouet.net/topic.php?which=9119&page=1#c429055
 */
export function solveCubic(
  t3: number,
  t2: number,
  t1: number,
  t0: number,
): number[] {
  const a = t2 / t3;
  const b = t1 / t3;
  const c = t0 / t3;
  const p = b - (a * a) / 3;
  const q = (a * (2 * a * a - 9 * b)) / 27 + c;
  const p3 = p * p * p;
  const d = q * q + (4 * p3) / 27;
  const offset = -a / 3;
  if (d >= 0) {
    // Single solution
    const z = Math.sqrt(d);
    const u = (-q + z) / 2;
    const v = (-q - z) / 2;
    const uRoot = Math.cbrt(u);
    const vRoot = Math.cbrt(v);
    return [offset + uRoot + vRoot];
  }
  const u = Math.sqrt(-p / 3);
  const v = Math.acos((-Math.sqrt(-27 / p3) * q) / 2) / 3;
  const m = Math.cos(v);
  const n = Math.sin(v) * 1.732050808;

  return [offset + u * (m + m), offset - u * (n + m), offset + u * (n - m)];
}
